/**
 * Gallery lightbox — fill the one shared dialog with the full-size render behind
 * whichever thumb was pressed.
 *
 * MicroModal opens the dialog itself: every thumb also carries
 * `data-micromodal-trigger`. This listens in the *bubble* phase, unlike
 * planZoom.js, and that is deliberate — the thumbs sit on a draggable Swiper
 * track, and Swiper swallows the click that ends a drag with a capture-phase
 * handler on the track. Bubbling behind it means a drag never opens the dialog.
 * Running after MicroModal's own handler costs nothing: both land in the same
 * task, so the dialog never paints before the image is set.
 */
export function initGalleryLightbox() {
    const modal = document.getElementById('gallery-lightbox-modal')
    if (!modal) return

    const image = modal.querySelector('[data-gallery-lightbox-image]')
    const title = modal.querySelector('[data-gallery-lightbox-title]')
    if (!image || !title) return

    image.addEventListener('load', () => image.classList.remove('opacity-0'))

    document.addEventListener('click', (event) => {
        const trigger = event.target.closest?.('[data-gallery-lightbox]')
        if (!trigger) return

        const thumb = trigger.querySelector('img')
        // `currentSrc` is whichever of the WebP or JPEG the <picture> settled on, so
        // the dialog reuses the file already in cache; it is empty only if the
        // slide was opened before its lazy image started loading.
        const src = thumb?.currentSrc || trigger.dataset.galleryLightbox
        const label = thumb?.alt ?? ''

        // Reopening the render already loaded fires no `load` to fade it back in,
        // so it is left visible; a new one is hidden until it has arrived.
        if (image.getAttribute('src') !== src) {
            image.classList.add('opacity-0')
            image.src = src
        }
        image.alt = label
        // Names the dialog, which is labelled by this element.
        title.textContent = label
    })
}
